<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'Publicacoes',
	title: 'Publicacoes'
}
</script>

<style scoped>
</style>
